const nonEmpty = (s) => {
  if (s == null) return '';
  const t = String(s).trim();
  return t || '';
};

/**
 * Stable "#" value for exports and labels: teamNumber, then legacy `number`, then doc id.
 * @param {object} team
 */
export function getTeamNumberDisplay(team) {
  const value = team?.teamNumber ?? team?.number ?? team?.id;
  return value == null || value === '' ? '?' : String(value);
}

/**
 * Human-readable team name (no team number prefix).
 * @param {object} team
 */
export function getTeamLabelCore(team) {
  if (!team) return '';
  const label =
    nonEmpty(team.teamName) ||
    nonEmpty(team.mentorName) ||
    nonEmpty(team.mentor?.name);
  if (label) return label;
  const num = getTeamNumberDisplay(team);
  return num !== '?' ? `Team ${num}` : 'Team ?';
}

/**
 * Full team label for grids and lists.
 * @param {object} team
 */
export function getTeamDisplayLabel(team) {
  const label = getTeamLabelCore(team);
  const num = getTeamNumberDisplay(team);
  if (num === '?') return label;
  const synthetic = `Team ${num}`;
  if (label === synthetic) return `#${num}`;
  return `#${num} — ${label}`;
}
